/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/*
 * Using this json only for 18F brand.
 */
const data = {
    header_data: {
        title: 'International Flower Delivery',
        title_color: '#52297e',
        sub_title: 'International flower and gift delivery is simple with 1-800-Flowers.com®! Whether you send gift baskets to Europe, fresh flowers to Asia, or plants to South America, your overseas recipient will love your thoughtful gift.',
        list_item: [
            ' Delivery to over 195 countries',
            'Same Day & Next-Day Delivery Available in Select Countries',
            'Hassle-free Order & Delivery',
            'Dedicated 24/7 Customer Service',
            '100% Smile Guarantee',
        ],
    },
    order_call_detial: {
        order_call_title: 'Ordering by phone is Easy! Just Call',
        list_call: [
            {
                name: ' From the US',
                call_number: '1-800-858-5039',
                call_color_no: '#52297e',
            },
            {
                name: ' From Australia',
                call_number: '1800 729 692',
                call_color_no: '#52297e',
            },
            {
                name: ' From Canada',
                call_number: '1-844-884-1371',
                call_color_no: '#52297e',
            },
            {
                name: ' From the UK',
                call_number: '0800 141 3273',
                call_color_no: '#52297e',
            },
        ],
        tips: {
            tipe_title: 'Tips for Sending',
            tip_link_color: '#52297e',
            tip_list: [
                {
                    tip_name: 'Tips for Sending Internationally',
                    url: '/international-tips',
                },
                {
                    tip_name: 'Gift Giving Do\'s and Dont\'s',
                    url: '/international-gift-giving',
                },
                {
                    tip_name: 'Fun Facts',
                    url: '/international-fun-facts',
                },
                {
                    tip_name: 'FAQ\'s',
                    url: '/international-delivery-faq',
                },
            ],
        },
    },
    trending_products: {
        trending_title: 'Trending Products In Top Countries',
        product_lists: [
            {
                image_url: '/90977c.jpg',
                image_title: 'United States',
                country_flag: '/usa.gif',
                url: '/bestsellingflowers',
            },
            {
                image_url: '/98742c.jpg',
                image_title: 'Australia',
                country_flag: '/australia.gif',
                url: '/australia',
            },
            {
                image_url: '/100299c.jpg',
                image_title: 'Canada',
                country_flag: '/canada.gif',
                url: '/canada',
            },
            {
                image_url: '/143719c.jpg',
                image_title: 'United Kingdom',
                country_flag: '/greatbritain.gif',
                url: '/england',
            },
            {
                image_url: '/142243c.jpg',
                image_title: 'Germany',
                country_flag: '/germany.gif',
                url: '/germany',
            },
            {
                image_url: '/105706c.jpg',
                image_title: 'Italy',
                country_flag: '/italy.gif',
                url: '/italy',
            },
            {
                image_url: '/98777c.jpg',
                image_title: 'Philippines',
                country_flag: '/philippines.gif',
                url: '/philippines',
            },
            {
                image_url: '/142248c.jpg',
                image_title: 'France',
                country_flag: '/france.gif',
                url: '/france',
            },
            {
                image_url: '/98655c.jpg',
                image_title: 'Japan',
                country_flag: '/japan.gif',
                url: '/japan',
            },
            {
                image_url: '/105363c.jpg',
                image_title: 'Mexico',
                country_flag: '/mexico.gif',
                url: '/mexico',
            },
        ],
        disclaimer_text: 'On birthdays, anniversaries, to say hello, or <strong>for any reason at all</strong>, it\' s always a treat to open the door to beautiful flowers and gourmet gifts. At 1-800-Flowers.com®, we deliver flowers and gifts almost anywhere in the world through a number of international affiliates.',
    },
    shop_by_country: {
        heading: 'Shop By Delivery Country',
        shop_link: [
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
            'N',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'T',
            'U',
            'V',
            'W',
            'Z',
        ],
        countries: {
            call_disclaimer: 'If your delivery country is below, you must call to shop: ',
            countries_list: [
                {
                    country_detail: [
                        {
                            country_name: 'Andorra',
                            url: '/andorra',
                            country_flag: '/andorra',
                        },
                        {
                            country_name: 'Angola',
                            url: '/international/angola-12510',
                            country_flag: '/angola',
                        },
                        {
                            country_name: 'Anguilla',
                            url: '/anguilla',
                            country_flag: '/anguilla',
                        },
                        {
                            country_name: 'Argentina',
                            url: '/argentina',
                            country_flag: '/argentina',
                        },
                        {
                            country_name: 'Armenia',
                            url: '/armenia',
                            country_flag: '/armenia',
                        },
                        {
                            country_name: 'Aruba',
                            url: '/aruba',
                            country_flag: '/aruba',
                        },
                        {
                            country_name: 'Australia',
                            url: '/australia',
                            country_flag: '/australia',
                        },
                        {
                            country_name: 'Austria',
                            url: '/austria',
                            country_flag: '/austria',
                        },
                    ],
                    call_number: '1-800-858-5039',
                    countries_names_list: 'Azerbajan, Antigua',
                    countryLetter: 'A',
                },
                {
                    country_detail: [
                        {
                            country_name: 'Bahamas',
                            url: '/international/bahamas-11934',
                            country_flag: '/bahamas',
                        },
                        {
                            country_name: 'Bahrain',
                            url: '/bahrain',
                            country_flag: '/bahrain',
                        },
                        {
                            country_name: 'Barbados',
                            url: '/barbados',
                            country_flag: '/barbados',
                        },
                        {
                            country_name: 'Belgium',
                            url: '/international/belgium-12400',
                            country_flag: '/belgium',
                        },
                        {
                            country_name: 'Belize',
                            url: '/belize',
                            country_flag: '/belize',
                        },
                        {
                            country_name: 'Bolivia',
                            url: '/bolivia',
                            country_flag: '/bolivia',
                        },
                        {
                            country_name: 'Brazil',
                            url: '/brazil',
                            country_flag: '/brazil',
                        },
                        {
                            country_name: 'Brunei',
                            url: '/brunei',
                            country_flag: '/brunei',
                        },
                        {
                            country_name: 'Bulgaria',
                            url: '/bulgaria',
                            country_flag: '/bulgaria',
                        },
                    ],
                    call_number: '1-800-858-5039',
                    countries_names_list: 'BENIN, BOTSWANA, BALERIC ISLANDS, BOSNIA-HERCEGOVINA, BERMUDA, BONAIRE, BRITISH VIRGIN ISLANDS',
                    countryLetter: 'B',
                },
                {
                    country_detail: [
                        {
                            country_name: 'Canada',
                            url: '/canada',
                            country_flag: '/canada',
                        },
                        {
                            country_name: 'Cayman Islands',
                            url: '/cayman-islands',
                            country_flag: '/cayman_islands',
                        },
                        {
                            country_name: 'Chile',
                            url: '/international/chile-12490',
                            country_flag: '/chile',
                        },
                        {
                            country_name: 'China',
                            url: '/china',
                            country_flag: '/china',
                        },
                        {
                            country_name: 'Colombia',
                            url: '/columbia',
                            country_flag: '/colombia',
                        },
                        {
                            country_name: 'Corsica',
                            url: '/corsica',
                            country_flag: '/corsica',
                        },
                        {
                            country_name: 'Costa Rica',
                            url: '/costa-rica-12486',
                            country_flag: '/costarica',
                        },
                        {
                            country_name: 'Cyprus',
                            url: '/cyprus',
                            country_flag: '/cyprus',
                        },
                        {
                            country_name: 'Czech Republic',
                            url: '/international/czechrepublic-12559',
                            country_flag: '/czechrepublic',
                        },
                    ],
                    call_number: '1-800-858-5039',
                    countries_names_list: '',
                    countryLetter: 'C',
                },
                {
                    country_detail: [
                        {
                            country_name: 'Denmark',
                            url: '/denmark',
                            country_flag: '/denmark',
                        },
                        {
                            country_name: 'Djibouti',
                            url: '/djibouti',
                            country_flag: '/djibouti',
                        },
                        {
                            country_name: 'Dominican Republic',
                            url: '/dominican-republic',
                            country_flag: '/dominicanrepublic',
                        },
                        {
                            country_name: 'Dominica',
                            url: '/dominica',
                            country_flag: '/dominica',
                        },
                        {
                            country_name: 'Dubai',
                            url: '/international/united-arab-emirates-12399',
                            country_flag: '/uae',
                        },
                    ],
                    call_number: '1-800-858-5039',
                    countries_names_list: '',
                    countryLetter: 'D',
                },
                {
                    country_detail: [
                        {
                            country_name: 'Ecuador',
                            url: '/ecuador',
                            country_flag: '/ecuador',
                        },
                        {
                            country_name: 'Egypt',
                            url: '/international/egypt-12511',
                            country_flag: '/egypt',
                        },
                        {
                            country_name: 'El Salvador',
                            url: '/international/el-salvador-12487',
                            country_flag: '/elsalvador',
                        },
                        {
                            country_name: 'England',
                            url: '/england',
                            country_flag: '/england',
                        },
                    ],
                    call_number: '1-800-858-5039',
                    countries_names_list: 'ERITREA, ESETONIA, ETHIOPIA',
                    countryLetter: 'E',
                },
                {
                    country_detail: [
                        {
                            country_name: 'Finland',
                            url: '/finland',
                            country_flag: '/finland',
                        },
                        {
                            country_name: 'France',
                            url: '/france',
                            country_flag: '/france',
                        },
                    ],
                    call_number: '1-800-858-5039',
                    countries_names_list: 'FAROE ISLANDS, FRENCH POLYNESIA ',
                    countryLetter: 'F',
                },
                {
                    country_detail: [
                        {
                            country_name: 'Germany',
                            url: '/germany',
                            country_flag: '/germany',
                        },
                        {
                            country_name: 'Georgia',
                            url: '/georgia',
                            country_flag: '/georgia',
                        },
                        {
                            country_name: 'Gibraltar',
                            url: '/gibraltar',
                            country_flag: '/gibraltar',
                        },

                        {
                            country_name: 'Great Britain',
                            url: '/international/greatbritain-12117',
                            country_flag: '/greatbritain',
                        },
                        {
                            country_name: 'Greece',
                            url: '/greece',
                            country_flag: '/greece',
                        },
                        {
                            country_name: 'Guam',
                            url: '/international/guam-12485',
                            country_flag: '/guam',
                        },
                        {
                            country_name: 'Guadaloupe',
                            url: '/guadaloupe',
                            country_flag: '/Guadaloupe',
                        },
                        {
                            country_name: 'Guatemala',
                            url: '/international/guatemala-12488',
                            country_flag: '/guatemala',
                        },
                        {
                            country_name: 'Guyana',
                            url: '/international/guyana-12394',
                            country_flag: '/guyana',
                        },
                    ],
                    call_number: '1-800-858-5039',
                    countries_names_list: 'GUANA, GABON, GUERNSEY, GREENLAND, GRENADA',
                    countryLetter: 'G',
                },
                {
                    country_detail: [
                        {
                            country_name: 'Hungary',
                            url: '/hungary',
                            country_flag: '/hungary',
                        },
                        {
                            country_name: 'Holland',
                            url: '/netherlands',
                            country_flag: '/holland',
                        },
                        {
                            country_name: 'Hong Kong',
                            url: '/hong-kong',
                            country_flag: '/hongkong',
                        },
                        {
                            country_name: 'Honduras',
                            url: '/honduras',
                            country_flag: '/honduras',
                        },
                    ],
                    call_number: '1-800-858-5039',
                    countries_names_list: 'HAITI ',
                    countryLetter: 'H',
                },
                {
                    country_detail: [
                        {
                            country_name: 'Iceland',
                            url: '/iceland',
                            country_flag: '/iceland',
                        },
                        {
                            country_name: 'India',
                            url: '/india',
                            country_flag: '/india',
                        },
                        {
                            country_name: 'Indonesia',
                            url: '/international/indonesia-12491',
                            country_flag: '/indonesia',
                        },
                        {
                            country_name: 'Ireland',
                            url: '/ireland',
                            country_flag: '/ireland',
                        },
                        {
                            country_name: 'Israel',
                            url: '/israel',
                            country_flag: '/israel',
                        },
                        {
                            country_name: 'Italy',
                            url: '/italy',
                            country_flag: '/italy',
                        },
                    ],
                    call_number: '1-800-858-5039',
                    countries_names_list: 'ISLE OF MAN',
                    countryLetter: 'I',
                },
                {
                    country_detail: [
                        {
                            country_name: 'Jamaica',
                            url: '/jamaica',
                            country_flag: '/jamaica',
                        },
                        {
                            country_name: 'Japan',
                            url: '/japan',
                            country_flag: '/japan',
                        },
                        {
                            country_name: 'Jordan',
                            url: '/jordan',
                            country_flag: '/jordan',
                        },
                    ],
                    call_number: '1-800-858-5039',
                    countries_names_list: 'JERSEY',
                    countryLetter: 'J',
                },
                {
                    country_detail: [
                        {
                            country_name: 'Kenya',
                            url: '/kenya',
                            country_flag: '/kenya',
                        },
                        {
                            country_name: 'Kuwait',
                            url: '/kuwait',
                            country_flag: '/kuwait',
                        },
                    ],
                    call_number: '1-800-858-5039',
                    countries_names_list: 'KAZAKHSTAN, KYRGYZSTAN',
                    countryLetter: 'K',
                },
                {
                    country_detail: [
                        {
                            country_name: 'Latvia',
                            url: '/latvia',
                            country_flag: '/latvia',
                        },
                        {
                            country_name: 'Lesotho',
                            url: '/lesotho',
                            country_flag: '/lesotho',
                        },
                        {
                            country_name: 'Liechtenstein',
                            url: '/liechtenstein',
                            country_flag: '/liechtenstein',
                        },
                        {
                            country_name: 'Lithuania',
                            url: '/lithuania',
                            country_flag: '/lithuania',
                        },
                        {
                            country_name: 'Luxembourg',
                            url: '/international/luxembourg-12401',
                            country_flag: '/luxembourg',
                        },
                    ],
                    call_number: '1-800-858-5039',
                    countries_names_list: '',
                    countryLetter: 'L',
                },
                {
                    country_detail: [
                        {
                            country_name: 'Macedonia',
                            url: '/macedonia',
                            country_flag: '/macedonia',
                        },
                        {
                            country_name: 'Malaysia',
                            url: '/malaysia',
                            country_flag: '/malaysia',
                        },
                        {
                            country_name: 'Malta',
                            url: '/malta',
                            country_flag: '/malta',
                        },
                        {
                            country_name: 'Mexico',
                            url: '/mexico',
                            country_flag: '/mexico',
                        },
                        {
                            country_name: 'Moldova',
                            url: '/moldova',
                            country_flag: '/moldova',
                        },
                        {
                            country_name: 'Montserrat',
                            url: '/montserrat',
                            country_flag: '/montserrat',
                        },
                        {
                            country_name: 'Montenegro',
                            url: '/montenegro',
                            country_flag: '/montenegro',
                        },
                        {
                            country_name: 'Morocco',
                            url: '/morocco',
                            country_flag: '/morocco',
                        },
                        {
                            country_name: 'Myanmar',
                            url: '/myanmar',
                            country_flag: '/myanmar',
                        },
                    ],
                    call_number: '1-800-858-5039',
                    countries_names_list: 'MACAU, MALAWI, MAURITIUS, MOZAMBIQUE, MARTINIQUE',
                    countryLetter: 'M',
                },
                {
                    country_detail: [
                        {
                            country_name: 'Nepal',
                            url: '/nepal',
                            country_flag: '/nepal',
                        },
                        {
                            country_name: 'New Zealand',
                            url: '/new-zealand',
                            country_flag: '/newzealand',
                        },
                        {
                            country_name: 'Nicaragua',
                            url: '/nicaragua',
                            country_flag: '/nicaragua',
                        },
                        {
                            country_name: 'Northern Ireland',
                            url: '/england',
                            country_flag: '/northernireland',
                        },
                        {
                            country_name: 'Norway',
                            url: '/norway',
                            country_flag: '/norway',
                        },
                    ],
                    call_number: '1-800-858-5039',
                    countries_names_list: 'NORFOLK ISLAND, NAMIBIA, NORTHERN MARIANA ISLANDS, NEW CALEDONIA',
                    countryLetter: 'N',
                },
                {
                    country_detail: [
                        {
                            country_name: 'Oman',
                            url: '/oman',
                            country_flag: '/oman',
                        },

                    ],
                    call_number: '1-800-858-5039',
                    countries_names_list: '',
                    countryLetter: 'O',
                },
                {
                    country_detail: [
                        {
                            country_name: 'Pakistan',
                            url: '/pakistan',
                            country_flag: '/pakistan',
                        },
                        {
                            country_name: 'Panama',
                            url: '/panama',
                            country_flag: '/panama',
                        },
                        {
                            country_name: 'Paraguay',
                            url: '/paraguay',
                            country_flag: '/paraguay',
                        },
                        {
                            country_name: 'Peru',
                            url: '/peru',
                            country_flag: '/peru',
                        },
                        {
                            country_name: 'Phillipines',
                            url: '/phillipines',
                            country_flag: '/philippines',
                        },
                        {
                            country_name: 'Poland',
                            url: '/international/poland-12111',
                            country_flag: '/poland',
                        },
                        {
                            country_name: 'Portugal',
                            url: '/portugal',
                            country_flag: '/portugal',
                        },
                    ],
                    call_number: '1-800-858-5039',
                    countries_names_list: 'PALAU, PAPUA NEW GUINNEA, PUERTO RICO',
                    countryLetter: 'P',
                },
                {
                    country_detail: [],
                    call_number: '1-800-858-5039',
                    countries_names_list: 'QATAR',
                    countryLetter: 'Q',
                },
                {
                    country_detail: [
                        {
                            country_name: 'Romania',
                            url: '/international/romania-12452',
                            country_flag: '/romania',
                        },
                    ],
                    call_number: '1-800-858-5039',
                    countries_names_list: 'REUNION',
                    countryLetter: 'R',
                },
                {
                    country_detail: [
                        {
                            country_name: 'San Marino',
                            url: '/san-marino',
                            country_flag: '/SanMarino',
                        },
                        {
                            country_name: 'Saudi Arabia',
                            url: '/international/saudi-arabia-12417',
                            country_flag: '/saudiarabia',
                        },
                        {
                            country_name: 'Senegal',
                            url: '/senegal',
                            country_flag: '/senegal',
                        },
                        {
                            country_name: 'Scotland',
                            url: '/scotland',
                            country_flag: '/scotland',
                        },
                        {
                            country_name: 'Singapore',
                            url: '/singapore',
                            country_flag: '/singapore',
                        },
                        {
                            country_name: 'Slovakia',
                            url: '/slovakia',
                            country_flag: '/slovakia',
                        },
                        {
                            country_name: 'Slovenia',
                            url: '/slovenia',
                            country_flag: '/slovenia',
                        },
                        {
                            country_name: 'South Africa',
                            url: '/south-africa',
                            country_flag: '/southafrica',
                        },
                        {
                            country_name: 'Spain',
                            url: '/spain',
                            country_flag: '/spain',
                        },
                        {
                            country_name: 'South Korea',
                            url: '/international/south-korea-12398',
                            country_flag: '/southkorea',
                        },
                        {
                            country_name: 'Suriname',
                            url: '/suriname',
                            country_flag: '/suriname',
                        },
                        {
                            country_name: 'Sweden',
                            url: '/sweden',
                            country_flag: '/sweden',
                        },
                        {
                            country_name: 'Swaziland',
                            url: '/swaziland',
                            country_flag: '/swaziland',
                        },
                        {
                            country_name: 'Switzerland',
                            url: '/switzerland',
                            country_flag: '/switzerland',
                        },
                    ],
                    call_number: '1-800-858-5039',
                    countries_names_list: 'SARDINIA, SAMOA, SEYCHELLES, ST. CROIX, ST. JOHN, ST. KITTS, ST. LUCIA, ST. PIERRE AND MIQUELON, ST. THOMAS, ST. VINCENTS AND THE GRENEDINES',
                    countryLetter: 'S',
                },
                {
                    country_detail: [
                        {
                            country_name: 'Taiwan',
                            url: '/international/taiwain-12408',
                            country_flag: '/taiwan',
                        },
                        {
                            country_name: 'Thailand',
                            url: '/international/thailand-12411',
                            country_flag: '/thailand',
                        },
                        {
                            country_name: 'Trinidad',
                            url: '/trinidad',
                            country_flag: '/Trinidad',
                        },
                        {
                            country_name: 'Tunisia',
                            url: '/international/tunisia-13354',
                            country_flag: '/tunisia',
                        },
                        {
                            country_name: 'Turkey',
                            url: '/turkey',
                            country_flag: '/turkey',
                        },
                        {
                            country_name: 'Turkmenistan',
                            url: '/turkmenistan',
                            country_flag: '/turkmenistan',
                        },
                    ],
                    call_number: '1-800-858-5039',
                    countries_names_list: 'TORTOLA, TAHITI',
                    countryLetter: 'T',
                },
                {
                    country_detail: [
                        {
                            country_name: 'United Arab Emirates',
                            url: '/international/united-arab-emirates-12399',
                            country_flag: '/uae',
                        },
                        {
                            country_name: 'United Kingdom',
                            url: '/england',
                            country_flag: '/greatbritain',
                        },
                        {
                            country_name: 'United States',
                            url: '/',
                            country_flag: '/usa',
                        },
                        {
                            country_name: 'Uruguay',
                            url: '/uruguay',
                            country_flag: '/uruguay',
                        },
                        {
                            country_name: 'Uzbekistan',
                            url: '/uzbekistan',
                            country_flag: '/uzbekistan',
                        },
                    ],
                    call_number: '1-800-858-5039',
                    countries_names_list: 'U.S. VIRGIN ISLANDS',
                    countryLetter: 'U',
                },
                {
                    country_detail: [
                        {
                            country_name: 'Venezuela',
                            url: '/venezuela',
                            country_flag: '/venezuela',
                        },
                        {
                            country_name: 'Vietnam',
                            url: '/international/vietnam-12532',
                            country_flag: '/vietnam',
                        },
                    ],
                    call_number: '1-800-858-5039',
                    countries_names_list: 'VATICAN CITY',
                    countryLetter: 'V',
                },
                {
                    country_detail: [
                        {
                            country_name: 'Wales',
                            url: '/england',
                            country_flag: '/wales',
                        },
                    ],
                    call_number: '1-800-858-5039',
                    countries_names_list: '',
                    countryLetter: 'W',
                },
                {
                    country_detail: [],
                    call_number: '1-800-858-5039',
                    countries_names_list: 'ZAMBIA',
                    countryLetter: 'Z',
                },
            ],
        },
    },
    seo: {
        page_title: 'Send Flowers Internationally | Gift Delivery | 1800Flowers.com',
        keywords: '',
        meta_description: 'International flower delivery is simple with the trusted international florist 1-800-Flowers.com! Send flowers, plants, and gifts baskets today.',
        location: { pathname: '/international-flower-delivery' },
    },
};
export default data;
